var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infinite-scroll"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPlaceholder),expression:"showPlaceholder"}],ref:"placeholder",staticClass:"infinite-scroll-placeholder"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }